import { useState, useEffect } from 'react';

const usePWAInstall = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallable, setIsInstallable] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [isAndroid, setIsAndroid] = useState(false);

  useEffect(() => {
    // Detectar iOS
    const ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    setIsIOS(ios);

    // Detectar Android
    const android = /Android/.test(navigator.userAgent);
    setIsAndroid(android);

    // Verificar se já está instalado
    const checkIfInstalled = () => {
      // Verifica se está rodando como PWA
      if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) {
        setIsInstalled(true);
        return true;
      }
      return false;
    };

    if (checkIfInstalled()) {
      return;
    }

    // Para iOS, não há beforeinstallprompt, então mostramos instruções manuais
    if (ios) {
      // No iOS, apenas mostramos que é instalável se não estiver instalado
      const alreadyInstalled = window.navigator.standalone;
      setIsInstallable(!alreadyInstalled);
      return;
    }

    // Para outros navegadores (Android Chrome, Desktop Chrome/Edge)
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsInstallable(true);
    };

    const handleAppInstalled = () => {
      setIsInstalled(true);
      setIsInstallable(false);
      setDeferredPrompt(null);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  const installPWA = async () => {
    if (!deferredPrompt) {
      return { success: false, reason: 'no_prompt' };
    }

    try {
      deferredPrompt.prompt();
      const choiceResult = await deferredPrompt.userChoice;

      if (choiceResult.outcome === 'accepted') {
        setDeferredPrompt(null);
        setIsInstallable(false);
        return { success: true };
      } else {
        return { success: false, reason: 'user_dismissed' };
      }
    } catch (error) {
      console.error('Erro ao instalar PWA:', error);
      return { success: false, reason: 'error', error };
    }
  };

  return {
    isInstallable,
    isInstalled,
    isIOS,
    isAndroid,
    installPWA
  };
};

export default usePWAInstall;
